import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {formatText} from 'common/util/format-text';
import {NAVIGATION_KEY_CODES} from 'common/util/dom';
import timing from 'common/stylesheets/mixins/timing.json';

import template from './index.jade';
import css from './index.styl?inline';

export class ContextPanelInternal extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      'tooltip-data': `json`,
    };
  }

  get config() {
    return {
      template,
      css,
      useShadowDom: true,
      defaultState: {
        delayRemove: timing[`$mp-fast`],
        description: {
          isEditing: false,
          text: ``,
          isChanged: false,
        },
      },
      helpers: {
        formatText,

        shouldShow: () => {
          const tooltipData = this.attr(`tooltip-data`);
          if (!tooltipData) {
            return false;
          }

          // Don't show tooltip if no values are defined
          return Object.values(tooltipData).some((v) => (Array.isArray(v) ? !!v.length : !!v));
        },

        handleTextEditorEditingStart: () => {
          this.update({description: {...this.state.description, isEditing: true}});
        },

        handleKeyPressToSave: (ev, item) => {
          if (ev.keyCode === NAVIGATION_KEY_CODES.ENTER && !ev.shiftKey) {
            this.helpers.handleTextEditorSave(ev, item);
            this.update({description: {...this.state.description, isEditing: false}});
          }
        },

        handleTextEditorSave: (ev, item) => {
          if (this.state.description.isChanged) {
            this.dispatchEvent(
              new CustomEvent(`changeDescription`, {
                detail: {description: this.state.description.text, item},
              }),
            );
          }

          this.update({description: {...this.state.description, isEditing: false, isChanged: false}});
        },

        handleTextEditorValueChange: (ev) => {
          if (this.state.description.isEditing) {
            this.update({description: {...this.state.description, isChanged: true, text: ev.target.value}});
          }
        },

        handleTextEditorInserted: ({elm}) => {
          if (this.state.description.isEditing) {
            elm.focus();
          }
        },

        handleMouseEnter: () => {
          this.dispatchEvent(new CustomEvent(`hoverIn`));
        },

        handleMouseLeave: () => {
          this.dispatchEvent(new CustomEvent(`hoverOut`));
        },

        actionClick: (ev, action) => {
          this.dispatchEvent(
            new CustomEvent(`actionClick`, {
              composed: true,
              cancelable: true,
              detail: {
                name: action.name,
                item: action.item,
              },
            }),
          );
        },

        getDisplayData: () => this.attr(`tooltip-data`) || {},
      },
    };
  }

  setDescription() {
    if (this.attr(`tooltip-data`)) {
      const {description} = this.attr(`tooltip-data`);
      this.update({description: {isEditing: false, isChanged: false, text: description || ``}});
    }
  }

  connectedCallback() {
    super.connectedCallback(...arguments);
    this.setDescription();
  }

  attributeChangedCallback(attr, oldVal, newVal) {
    super.attributeChangedCallback(attr, oldVal, newVal);
    if (attr === `tooltip-data`) {
      this.setDescription();
    }
  }
}

export const ContextPanelInternalEl = defineAndMakeJsxFactory(`mp-context-panel-internal`, ContextPanelInternal);
